import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import NotData from '../../components/NotData';
import { useNavigate } from 'react-router-dom';
import { Toast } from '../../common/message';
import { elapsedTime } from '../../common/howDate';
import UserPointExp from '../../common/UserPointExp';
import BottomChat from './Components/BottomChat';

const Order_list = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
    
  const [books, setBooks] = useState([]);
  const columns = [
    'No', '메모', '중요도', '최초요청', '브랜드', '분류', '제품 이름',  '탄방', '둔산', '자양', '충대', '합계'
  ];
  
  const basicStore = window.sessionStorage.getItem('basicStore');
  const basicPermission = window.sessionStorage.getItem('basicPermission');

  const [itemNo, setItemNo] = useState(0);
  const [ItemName, setItemName] = useState('');
  const [itemCount, setItemCount] = useState(0);
  const [orderTB, setOrderTB] = useState(0);
  const [orderDS, setOrderDS] = useState(0);
  const [orderJY, setOrderJY] = useState(0);
  const [orderCD, setOrderCD] = useState(0);

  const [orderMemo, setOrderMemo] = useState(''); // 완료, 삭제시 메모
  const [orderDate, setOrderDate] = useState(''); // 최초 요청 시간

  // 수량 업 다운
  const ItemCount_Down5 = ()=>{
    if(itemCount <= 0 || itemCount < 5) return;
    setItemCount(itemCount - 5);
  }
  const ItemCount_Down = ()=>{
    if(itemCount <= 0) return;
    setItemCount(itemCount - 1);
  }
  const ItemCount_Up = ()=>{
    setItemCount(itemCount + 1);
  }
  const ItemCount_Up5 = ()=>{
    setItemCount(itemCount + 5);
  }
  
  useEffect(()=>{
    document.title = '요청 목록';

    const loadeData = async ()=>{
      await Axios.get(`/api/order_list/orderlist/`)
      .then((res)=>{
        if(res.data.length)
        {
          setBooks(res.data);
        } else {
          setBooks([]);
        }
      })
    }
    loadeData();
  }, [])

  // 주문 요청 완료 및 삭제 함수
  const orderOK_NO = async (value)=>{
    await Axios.put(`/api/order_list/orderno`, {
      itemNo: itemNo, itemCount: itemCount, orderMemo: orderMemo,
      userId: window.sessionStorage.getItem('basicID'), date: toDay.time,
      store: window.sessionStorage.getItem('basicStore'), step: value
    })
    .then((res)=>{
      // 처리 즉시 리스트에 반영
      setBooks(books.filter(item => item.no !== itemNo));
      reset();
      if(value === '완료'){
        Toast.fire({ icon: "success", text: `${ItemName} 주문 완료` });
      } else {
        Toast.fire({ icon: "success", text: `${ItemName} 주문 삭제` });
      }
    })
  }

  // 주문 요청 취소시 타 매장에 수량이 있으면 내꺼만 수량 수정
  const orderCancelno = async ()=>{ 
    await Axios.put(`/api/order_list/ordercancelno`, {
      itemNo: itemNo, store: window.sessionStorage.getItem('basicStore')
    })
    .then((res)=>{
      // 처리 즉시 리스트에 반영
      setBooks(books.filter(item => item.no !== itemNo));
    })
  }

  // 주문 요청 취소시 타 매장에 수량이 없으면 취소처리
  const orderCancelok = async ()=>{
    await Axios.put(`/api/order_list/ordercancelok`, {
      itemNo: itemNo
    })
    .then((res)=>{
      // 처리 즉시 리스트에 반영
      setBooks(books.filter(item => item.no !== itemNo));
    })
  }

  // 주문완료 버튼
  const btnOrderOK = async ()=>{
    if(basicPermission < 4) return alert('관리자만 이용 가능합니다');
    if(!itemNo) return alert('품목을 선택해 주세요');
    if(!window.confirm(`${ItemName}을 주문 완료 처리하시겠습니까?`)) return;
    orderOK_NO('완료');
  }

  // 주문삭제 버튼
  const btnOrderNO = async ()=>{
    if(basicPermission < 4) return alert('관리자만 이용 가능합니다');
    if(!itemNo) return alert('품목을 선택해 주세요');
    if(!window.confirm(`${ItemName}을 주문 삭제 처리하시겠습니까?`)) return;
    orderOK_NO('삭제');
  }

  // 주문취소 버튼
  const btnOrderCanel = async ()=>{

    let count = 0;
    switch(basicStore){
      case '탄방점' : count = orderTB; break;
      case '둔산점' : count = orderDS; break;
      case '자양점' : count = orderJY; break;
      case '충대점' : count = orderCD; break;
      default : break;
    }

    if(!itemNo) return alert('품목을 선택해 주세요');
    if(count === 0) return alert(`${basicStore}은 취소할 수량이 없습니다`);
    if(!window.confirm(`${ItemName} 주문 요청을 취소하시겠습니까?`)) return;
    
    // 타 매장에 수량이 있을시 0개로 수정
    const mystore = window.sessionStorage.getItem('basicStore');
    if(mystore === '탄방점'){
      if(orderDS === 0 && orderJY === 0 && orderCD === 0){
        orderCancelok();
      } else {
        orderCancelno();
      }
    } else if (mystore === '둔산점'){
      if(orderTB === 0 && orderJY === 0 && orderCD === 0){
        orderCancelok();
      } else {
        orderCancelno();
      }
    } else if (mystore === '자양점'){
      if(orderDS === 0 && orderTB === 0 && orderCD === 0){
        orderCancelok();
      } else {
        orderCancelno();
      }
    } else if (mystore === '충대점'){
      if(orderDS === 0 && orderJY === 0 && orderTB === 0){
        orderCancelok();
      } else {
        orderCancelno();
      }
    } else {
      return alert('주문 취소가 불가능합니다.')
    }

    Toast.fire({ icon: "success", text: `${ItemName} 주문 요청 취소` });
    // 타 매장에 수량이 없을시 step 취소로 수정

    // 포인트 및 기여도 지급
    UserPointExp('주문관리', `${ItemName} 주문요청 취소`, 1, 1, '차감');
  }

  // 리셋
  const reset = ()=>{
    setItemName('');
    setItemCount(0);
    setItemNo(0);
    setOrderMemo('');

    setSelectedRow(-1);
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);
  
  const navigate = useNavigate();

  // 매장별 메모, 아이디 날짜
  const [memoDataTB, setMemoDataTB] = useState({});
  const [memoDataDS, setMemoDataDS] = useState({});
  const [memoDataJY, setMemoDataJY] = useState({});
  const [memoDataCD, setMemoDataCD] = useState({});

  return (
    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
    <div className='flex justify-between items-center'>
      <ul className='flex gap-3'>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/order/order')}>주문요청</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={()=>navigate('/order/list')}>요청목록</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/order/state')}>처리완료</li>
      </ul>
      {/* <div>
        <button className='px-3 py-2 text-yellow-400'>새로고침</button>
      </div> */}
    </div>

    <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-1'>

    <div className='flex flex-col justify-between gap-1 md:w-3/4 w-full'>

      {/* 메인 */}
      <div className='relative border-[1px] border-gray-500 w-full md:h-full h-[60vh] overflow-y-auto'>
        <table id='testTable' className='w-full'>
          <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10'>
            <tr className='border-b-[1px] border-gray-500'>
              {columns.map((column) => (
                <th className='p-3' key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody className='text-center'>
            {
              books.length ?
              books.map((book, idx) => (
                <tr className=
                {`
                  duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                  ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                `}
                key={book.no} onClick={(e)=>{
                  setSelectedRow(idx);
                  setItemNo(book.no);
                  setItemName(book.name);
                  setItemCount(book.order_TB + book.order_DS + book.order_JY + book.order_CD);
                  setOrderDate(book.date);

                  // 주문취소시 타 매장 수량 체크
                  setOrderTB(book.order_TB);
                  setOrderDS(book.order_DS);
                  setOrderJY(book.order_JY);
                  setOrderCD(book.order_CD);

                  // 매장별 메모 데이터 받기
                  setMemoDataTB({ memo: book.memo_TB, id: book.TB_id, date: book.TB_date });
                  setMemoDataDS({ memo: book.memo_DS, id: book.DS_id, date: book.DS_date });
                  setMemoDataJY({ memo: book.memo_JY, id: book.JY_id, date: book.JY_date });
                  setMemoDataCD({ memo: book.memo_CD, id: book.CD_id, date: book.CD_date });

                  window.sessionStorage.setItem('select_copy', book.name);
                }}>
                  <td className='p-2.'>{idx + 1}</td>
                  <td className={`p-2.5 border-x-[1px] border-gray-500
                  ${(book.memo_TB || book.memo_DS || book.memo_JY || book.memo_CD) && 'animate-pulse'}
                  `}>
                    {(book.memo_TB || book.memo_DS || book.memo_JY || book.memo_CD) ? "📝" : "-"}
                  </td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>
                    <p className=
                    {`
                      ${book.state === 1 && 'px-2 py-1 bg-gray-600 rounded-sm'}
                      ${book.state === 2 && 'px-2 py-1 bg-yellow-500/80 rounded-sm'}
                      ${book.state === 3 && 'px-2 py-1 bg-red-500/80 rounded-sm animate-pulse'}
                    `}>
                      {book.state === 1 && '보통'}
                      {book.state === 2 && '중요'}
                      {book.state === 3 && '긴급'}
                    </p>
                  </td>
                  <td className={`p-2.5 border-x-[1px] border-gray-500 ${elapsedTime(book.date) === '방금 전' && 'animate-pulse'}`}>
                    {elapsedTime(book.date)}
                  </td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.brand}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.type}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                  <td className='p-2.5'>{ book.order_TB === 0 ? '-' : book.order_TB }</td>
                  <td className='p-2.5'>{ book.order_DS === 0 ? '-' : book.order_DS }</td>
                  <td className='p-2.5'>{ book.order_JY === 0 ? '-' : book.order_JY }</td>
                  <td className='p-2.5'>{ book.order_CD === 0 ? '-' : book.order_CD }</td>
                  <td className='p-2.5 border-l-[1px] border-gray-500' style={{fontFamily: 'Gugi'}}>
                    { book.order_TB + book.order_DS + book.order_JY + book.order_CD }
                  </td>
                </tr>
              ))
              :
              <tr className='relative'>
                <td className='absolute w-full top-[30vh] left-auto'>
                  <NotData/>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      {/* 하단 판매금액 */}        
      <div className={`flex flex-col w-full overflow-x-auto overflow-y-hidden h-[25vh] md:h-64 border-[1px] border-gray-500`}>
        <div className="bg-[#0067BD] h-10 py-2 text-center">
          <p className="text-left pl-3 whitespace-nowrap">
            ※ 매장별 주문 요청 관련 참고사항
          </p>
        </div>

        <div className="flex h-full overflow-y-hidden overflow-x-auto bg-[#3E3E3E]">
          <div className={`flex whitespace-nowrap flex-auto justify-center items-center`}>
            {
              (!memoDataTB.memo && !memoDataDS.memo && !memoDataJY.memo && !memoDataCD.memo) ?
              <div className=''>
                <p className='text-base tracking-wide duration-150 animate-pulse' style={{fontFamily: 'Gugi'}}>메모를 남긴 매장이 없습니다</p>
              </div>
              :
              <>
                <BottomChat store={ '탄방점' } data={ { memo: memoDataTB.memo, id: memoDataTB.id, date: memoDataTB.date } }/>
                <BottomChat store={ '둔산점' } data={ { memo: memoDataDS.memo, id: memoDataDS.id, date: memoDataDS.date } }/>
                <BottomChat store={ '자양점' } data={ { memo: memoDataJY.memo, id: memoDataJY.id, date: memoDataJY.date } }/>
                <BottomChat store={ '충대점' } data={ { memo: memoDataCD.memo, id: memoDataCD.id, date: memoDataCD.date } }/>
              </>
            }
          </div>
        </div>
      </div>
    </div>

    {/* 사이드 */}
    <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>
      <div className='bg-[#0067BD] py-2 text-center'>
        <p className='text-left pl-3'>
          ※ 제품 주문 요청
        </p>
      </div>

      <div className='p-3 flex flex-col gap-2'>

      {/* 제품 이름 및 수량 */}
      <div className='w-full'>
        <p>제품 이름</p>
        <input className='bg-[#2E2E2E] mt-2 rounded-t-md w-full h-[70px] text-center font-bold border-b-[1px] hover:border-blue-500 border-gray-400' placeholder='〈 제품을 선택하세요 〉' disabled type='text' value={ItemName}/>
      </div>

      <div className={`${basicPermission < 4 ? 'hidden' : 'inline'} flex flex-col justify-center gap-2`}>
        <p className='whitespace-nowrap'>확정 수량</p>
        <div className='flex justify-center items-center gap-1 w-full'>
          <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
          onClick={ItemCount_Down5}>
            {'《'}
          </button>
          <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
          onClick={ItemCount_Down}>
            {'〈'}
          </button>
          <div className='bg-[#2E2E2E] py-2.5 rounded-md'>
            <p className='whitespace-nowrap w-20 text-center' id='item_count'>
              {`${itemCount} 개`}
            </p>
          </div>
          <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
          onClick={ItemCount_Up}>
            {'〉'}
          </button>
          <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
          onClick={ItemCount_Up5}>
            {'》'}
          </button>
        </div>
      </div>

      <div className={`${basicPermission < 4 ? 'hidden' : 'inline'} flex flex-col gap-2 w-full`}>
        <div className='flex justify-between'>
          <p className=''>참고사항</p>
          <button className='px-2 text-yellow-400' onClick={()=>alert('텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.')}>
            펼치기
          </button>
        </div>
        <div className='flex flex-col justify-center items-center'>
          <textarea className='h-20 bg-[#2E2E2E] mt-2 focus:border-[#2E2E2E] focus:scale-105 hover:border-gray-500 duration-150 w-full p-2 rounded-md outline-none border-[1px] border-gray-400'
          placeholder='〈 주문 완료 및 삭제시 참고사항 〉' type='text' value={orderMemo} onChange={(e)=>{
            setOrderMemo(e.target.value);
          }} />
        </div>
      </div>

      {/* 판매 날짜 */}
      <div id='priceText' className='flex flex-col justify-center gap-3'>
        <p>최초 요청 날짜</p>
        <input className='bg-[#2E2E2E] h-12 rounded-md text-center' disabled type='text' placeholder='〈 제품을 선택하세요 〉' value={orderDate} />
      </div>

      {/* 주문 요청 */}
      <div className={`${basicPermission < 4 ? 'hidden' : 'inline'} flex flex-col gap-2 pt-2`}>
        <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-sm text-center border-[1px] border-blue-500/80 duration-150 hover:scale-[0.98] active:border-none' onClick={btnOrderOK} >
          주문 완료
        </button>
        <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-sm text-center border-[1px] border-red-500/80 duration-150 hover:scale-[0.98] active:border-none' onClick={btnOrderNO} >
          주문 요청 삭제
        </button>
      </div>

      {/* 언더라인 */}
      <div className='border-b-[1px] border-gray-400 py-1'></div>

      {/* 주문 요청 취소 */}
      <div className='flex flex-col gap-2 pt-2'>
        <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-sm text-center border-[1px] border-yellow-500/80 duration-150 hover:scale-[0.98] active:border-none' onClick={btnOrderCanel} >
          주문 요청 취소
        </button>
      </div>

      <div className='flex whitespace-normal text-xs mt-3 gap-5 bg-[#2E2E2E] rounded-md p-5'>
        <div className='min-w-[30px] h-[30px] bg-yellow-500/80 rounded-md text-center'>
          <span className='text-2xl font-bold'>!</span>
        </div>
        <div className='text-center'>
          <span>※ 주문 요청 목록은 <span className='text-green-300'>이용이 제한되며 </span> <u className='text-red-400'>관리자만</u> 이용이 가능합니다.</span>
          <span className='text-gray-400'>관리자 외 사용자는 `요청 취소`만 가능합니다. 다시 한번 확인 후 처리해 주세요.</span>
        </div>
      </div>

    </div>
    </div>

    </div>

  </div>    
  )
}

export default Order_list